export default __webpack_public_path__ + "static/media/040-magic mirror.02545b5b.svg";